import PreviewModal from "./PreviewModal";
import CrewCard from "../../cards/CrewCard";


/**
 * @param param0
 * @param param0.crew {SC_CrewBase}
 * @return {JSX.Element}
 * @constructor
 */
const CrewPreviewModal = ({crew, nullValue}) => {
    const alias = crew?.alias ?? <i>{nullValue}</i>;

    return <PreviewModal modalTitle={<span>Viewing Crew: {alias}</span>} linkPermissions={(perms) => perms.scheduleService} linkContent={alias}>
        <CrewCard crew={crew} />
    </PreviewModal>;
}

export default CrewPreviewModal;